import { render } from "./MainForm.vue?vue&type=template&id=73ded603"
import script from "./MainForm.vue?vue&type=script&lang=js"
export * from "./MainForm.vue?vue&type=script&lang=js"

import "./MainForm.vue?vue&type=style&index=0&id=73ded603&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__